<template>
  <a-modal
    :width="modalWidth"
    :visible="visible"
    title="标签选择"
    :confirmLoading="confirmLoading"
    @ok="typeChange"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
  >
    <!--部门树-->
    <template>
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="标签组"
        >
          <a-tree
            multiple
            treeCheckable="tree"
            checkable
            @expand="onExpand"
            :expandedKeys="expandedKeysss"
            :checkedKeys="checkedKeys"
            allowClear="true"
            @check="onCheck"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
            :treeData="departTree"
            :replaceFields="{ title: 'name', key: 'id' }"
            v-decorator="[
              'tags',
              { rules: [{ required: true, message: '请选择标签!' }] }
            ]"
          >
          </a-tree>
        </a-form-item>
      </a-form>
    </template>
    <a-modal
      :width="modalWidth"
      :visible="show"
      title="确定框"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit"
      @cancel="handleCancel1"
      cancelText="关闭"
      wrapClassName="ant-modal-cust-warp"
      >{{ this.text }}
    </a-modal>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick';
import { getAction } from '@/api/manage';
import {
  queryIdTree,
  getLabelAll,
  addLabel,
  removeLabel,
  emptyLabel
} from '@/api/api';
import userModal from '../../system/modules/UserModal';

export default {
  name: 'TagWindow',
  components: {
    userModal
  },

  data() {
    return {
      text: '',
      show: false,
      checkedList: [],
      selectedRowKeys: [],
      checkedKeys: [], // 存储选中的部门id
      expandedKeysss: [], //展开的节点
      userId: '', // 存储用户id
      model: {}, // 存储SysUserDepartsVO表
      userDepartModel: { userId: '', departIdList: [] }, // 存储用户id一对多部门信息的对象
      departList: [], // 存储部门信息
      parentName: [], //存储父节点名子
      modalWidth: 400,
      departTree: [],
      title: '操作',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        userId: process.env.VUE_APP_CMS_SYSTEM + '/sys/user/generateUserId' // 引入生成添加用户情况下的url
      }
    };
  },
  // inject: ['reload'],
  mounted() {
    this.queryDepartTree();
  },
  methods: {
    add(key, selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
      this.key = key;
      this.edit();
    },
    typeChange(e) {
      this.show = true;
      if (this.key === '1') {
        this.text = '确定添加吗？';
      } else if (this.key === '2') {
        this.text = '确定移除吗？';
      } else if (this.key === '4') {
        this.text = '确定删除吗？';
      } else {
        this.text = '确定该选项吗？';
      }
    },
    edit(record) {
      this.departList = [];
      this.form.resetFields();
      if (this.key !== '3') {
        this.visible = true;
      }
      this.model = Object.assign({}, record);
      let filedsVal = pick(this.model, 'id', 'userId', 'departIdList');
      this.$nextTick(() => {
        this.form.setFieldsValue(filedsVal);
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.departList = [];
      this.checkedKeys = [];
    },
    handleSubmit(record) {
      var list = this.departList;
      if (this.key === '1') {
        var add_tag = [];
        for (var i = 0; i < list.length; i++) {
          add_tag.push(list[i].key);
        }
        let formData = {
          user: this.selectedRowKeys,
          add_tag: add_tag
        };
        this.loading = true;
        this.confirmLoading = true;
        addLabel(formData).then(res => {
          if (res.success) {
            this.show = false;
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message + '请检查是否依次进行添加');
          }
          this.confirmLoading = false;
          this.loading = false;
          this.$emit('searchReset');
          // this.reload()
          this.close();
        });
      } else if (this.key === '2') {
        var remove_tag = [];
        for (var i = 0; i < list.length; i++) {
          remove_tag.push(list[i].key);
        }
        let formData = {
          user: this.selectedRowKeys,
          remove_tag: remove_tag
        };
        this.loading = true;
        this.confirmLoading = true;
        removeLabel(formData).then(res => {
          if (res.success) {
            this.show = false;
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
          this.confirmLoading = false;
          this.$emit('searchReset');
          // this.reload()
          this.close();
        });
      } else if (this.key === '3') {
        let formData = {
          user: this.selectedRowKeys
        };
        this.loading = true;
        emptyLabel(formData).then(res => {
          if (res.success) {
            this.$message.success(res.message);
          } else {
            this.$message.success(res.message);
          }
          this.loading = false;
          this.$emit('searchReset');
          // this.reload()
          this.close();
        });
      } else if (this.key === '5') {
        this.show = false;
        this.confirmLoading = true;
        let formData = new FormData();
        formData.selectedRowKeys = this.checkedKeys;
        formData.departIdList = this.departList;
        this.$emit('ok', formData);
        this.confirmLoading = false;
        this.close();
      } else if (this.key === '6') {
        this.show = false;
        let formData = new FormData();
        formData.selectedRowKeys = this.selectedRowKeys;
        formData.departIdList = this.departList;
        this.$emit('ok', formData);
        this.close();
      } else {
        this.close();
      }
    },
    handleCancel() {
      this.close();
    },

    handleCancel1() {
      this.show = false;
    },
    // 选择部门时作用的API
    onCheck(checkedKeys, info) {
      this.departList = [];
      this.checkedKeys = checkedKeys;
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = { key: '', value: '', title: '', parentName: '' };
        depart.key = de.id;
        depart.value = de.name;
        depart.title = de.name;
        depart.parentName = de.dataRef.parentid;
        if (!de.dataRef.children) {
          this.departList.push(depart);
        }
      }
      this.form.setFieldsValue({
        tags
      });
      // console.log('onCheck', checkedKeys, info,this.departList);
    },
    queryDepartTree() {
      getLabelAll().then(res => {
        if (res.success) {
          this.departTree = res.result;
          this.departTree.map(e => (e.disableCheckbox = false));
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach(item => {
                treekey.push(item.key);
              });
              this.expandedKeysss = treekey;
            }
          }
        }
      });
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
    }
  }
};
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
